import { render, staticRenderFns } from "./FollowerForm.vue?vue&type=template&id=b37704e8&scoped=true&"
import script from "./FollowerForm.vue?vue&type=script&lang=js&"
export * from "./FollowerForm.vue?vue&type=script&lang=js&"
import style0 from "./FollowerForm.vue?vue&type=style&index=0&id=b37704e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37704e8",
  null
  
)

export default component.exports